import { Box } from "@mui/material";
import { FC } from "react";
import logo from "@/assets/images/logo.svg";

export const LoginLogo: FC = () => {
  return (
    <Box
      sx={{
        mt: 3,
        mb: 3,
        px: 4,
        py: 4,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 320,
        }}
      >
        <img
          src={logo}
          alt="irohana study"
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>
    </Box>
  );
};
